import { useState, useCallback } from 'react';

export const useModelSelection = (hasSubscription, onChange) => {
  const [showAlert, setShowAlert] = useState(false);
  const [pendingModelSelection, setPendingModelSelection] = useState(null);

  const handleOptionClick = useCallback(async (option, event, setIsOpen) => {
    event.stopPropagation();

    if (option.isPremium && !hasSubscription) {
      setShowAlert(true);
      return;
    }
    
    onChange(option.value);
    setIsOpen(false);
  }, [hasSubscription, onChange]);

  const handleAlertClose = () => {
    setShowAlert(false);
  };

  return {
    showAlert,
    pendingModelSelection,
    handleOptionClick,
    handleAlertClose
  };
};